module.exports = __webpack_public_path__ + "static/media/hand-point-left.17adaa9c.svg";